import removeListener from '../off/_removelistener.js';
import triggerOne from '../trigger/_triggerone.js';
import forEach from '../_helpers/foreach.js';
import assign from '../_helpers/assign.js';
var spaceReg = /\s+/;
export default function removeBinding(_ref) {
  var object = _ref.object,
    key = _ref.key,
    eventOptions = _ref.eventOptions,
    binding = _ref.binding;
  var bindingOptions = binding.bindingOptions,
    binder = binding.binder,
    node = binding.node,
    nodeHandler = binding.nodeHandler,
    objectHandler = binding.objectHandler,
    syncNodeHandler = binding.syncNodeHandler;
  var debouncedNodeHandler = binding.debouncedNodeHandler,
    debouncedObjectHandler = binding.debouncedObjectHandler;
  var destroy = binder.destroy,
    on = binder.on;
  var silent = eventOptions.silent;
  // a custom "on" function can't be turned off (binder.destroy should do it), so the handler ignores further calls
  if (syncNodeHandler) {
    syncNodeHandler.disabled = true;
  }
  // drop the updates still waiting for their debounce delay
  debouncedNodeHandler == null || debouncedNodeHandler.cancel();
  debouncedObjectHandler == null || debouncedObjectHandler.cancel();
  if (typeof on === 'string') {
    // remove DOM event listener
    // removeEventListener is faster than "on" method from any DOM library
    forEach(on.split(spaceReg), function (evtName) {
      return node.removeEventListener(evtName, nodeHandler);
    });
  }
  // remove object event listener; a binder without setValue has none, and no handler would mean "all of them"
  if (objectHandler) {
    removeListener(object, "_change:bindings:" + key, objectHandler);
  }
  // if binder.destroy is given call it
  if (destroy) {
    destroy.call(node, bindingOptions);
  }
  var extendedEventOptions = assign({
    key: key,
    node: node
  }, eventOptions);
  // DOM listeners ("click::x") leave the node even when the unbinding is silent
  triggerOne(object, "_unbind:" + key, extendedEventOptions);
  // fire events
  if (!silent) {
    triggerOne(object, "unbind:" + key, extendedEventOptions);
    triggerOne(object, 'unbind', extendedEventOptions);
  }
}